import { InjectionToken } from '@angular/core'

/**
 * Optional per-tenant opt-in. When true, `EntityDetailComponent` prepends a
 * breadcrumb link to the current type's list view, so root entities without
 * ancestors still offer a one-click path back to the list. Tenants that
 * don't provide this token keep the original breadcrumb shape.
 */
export const ENTITY_DETAIL_SHOW_LIST_BREADCRUMB = new InjectionToken<boolean>(
  'ENTITY_DETAIL_SHOW_LIST_BREADCRUMB'
)
